import script from "./BaseError.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseError.vue?vue&type=script&setup=true&lang=js"

import "./BaseError.vue?vue&type=style&index=0&id=6fe108cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe108cc"]])

export default __exports__